import React from 'react';
var StepInProgressIcon = function (_a) {
    var active = _a.active;
    return (React.createElement("svg", { width: 32, height: 32, viewBox: "0 0 32 32", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("circle", { cx: 16, cy: 16, r: 15, strokeWidth: 2, className: "".concat(active ? 'stroke-primary' : 'stroke-[#E9EDF7]') }),
        React.createElement("circle", { cx: 16, cy: 16, r: 5, className: "".concat(active ? 'fill-primary' : 'fill-[#E9EDF7]') })));
};
export default StepInProgressIcon;
